import { useEffect } from 'react';
import { scheduleGtagIfConsented } from './analytics';

export default function AnalyticsConsentLoader() {
  useEffect(() => {
    scheduleGtagIfConsented();
  }, []);
  return null;
}
